import React, { useEffect, useState } from "react";

import { loadStyles } from "../../utils/cssLoader";

const CricketPlayerMatches = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState("all");

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketplayer");
    }
  }, [loadCSS]);

  const data = dataClient ? clientData : ServerData;
  const matchesData = data?.data;

  if (!matchesData || matchesData.length === 0) {
    return (
      <div className="cricket-player-matches">
        <div className="no-data-message">{dictionary?.noMatches || "No matches available"}</div>
      </div>
    );
  }

  // Get all formats from tournaments
  const allFormats = ["all"];
  matchesData.forEach((tournament) => {
    tournament.matches?.forEach((match) => {
      if (match.mty && !allFormats.includes(match.mty)) {
        allFormats.push(match.mty);
      }
    });
  });

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getFilteredMatches = () => {
    let allMatches = [];
    matchesData.forEach((tournament) => {
      tournament.matches?.forEach((match) => {
        allMatches.push({
          ...match,
          tournamentName: tournament.nm,
        });
      });
    });

    if (selectedFormat !== "all") {
      allMatches = allMatches.filter((match) => match.mty === selectedFormat);
    }

    return allMatches;
  };

  const filteredMatches = getFilteredMatches();

  return (
    <>
      {title && <h1>{title}</h1>}
      <div className="cricket-player-matches">
        <div className="matches-card">
          <div className="matches-card-header">
            <h3 className="matches-title">{dictionary?.recentMatches || "Recent Matches - Player"}</h3>
            <div className="matches-filters">
              <select
                className="matches-dropdown"
                value={selectedFormat}
                onChange={(e) => setSelectedFormat(e.target.value)}
              >
                {allFormats.map((format) => (
                  <option key={format} value={format}>
                    {format === "all" ? (dictionary?.allFormats || "All Formats") : format}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="matches-card-body">
            <div className="matches-table-wrapper">
              <table className="matches-table">
                <thead>
                  <tr>
                    <th>{dictionary?.match || "Match"}</th>
                    <th>{dictionary?.bat || "Bat"}</th>
                    <th>{dictionary?.date || "Date"}</th>
                    <th>{dictionary?.ground || "Ground"}</th>
                    <th>{dictionary?.format || "Format"}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMatches.map((match, index) => {
                    const homeTeam = match.competitors?.htn || "";
                    const awayTeam = match.competitors?.atn || "";
                    const matchName = `${homeTeam} vs ${awayTeam}`;
                    const ground = match.stad?.cty || "-";

                    return (
                      <tr key={index}>
                        <td className="match-name-cell">{matchName}</td>
                        <td className="bat-cell">{formatValue(match.mno)}</td>
                        <td>{formatDate(match.d)}</td>
                        <td>{ground}</td>
                        <td className="format-cell">{formatValue(match.mty)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CricketPlayerMatches;
